import { render, staticRenderFns } from "./codeScan.vue?vue&type=template&id=167e8a24&scoped=true&"
import script from "./codeScan.vue?vue&type=script&lang=js&"
export * from "./codeScan.vue?vue&type=script&lang=js&"
import style0 from "./codeScan.vue?vue&type=style&index=0&id=167e8a24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e8a24",
  null
  
)

export default component.exports